import { Outlet } from 'react-router-dom';

export function WorkshopLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  );
}
